import { IFilterData } from 'src/typings/filter';
import { isString } from 'lodash';

export const getPlacementTypeByPropsRating = (filterData: IFilterData, getParams: URLSearchParams) => {
  const rating: {[key: string]: number} = {};
  Object.keys(filterData).forEach((placementsType: string) => {
    filterData[placementsType].filter_default_values.forEach((value) => {
      if (!rating?.[placementsType]) rating[placementsType] = 0;
      getParams.forEach((paramValue, key) => {
        if (value.attribute === key) {
          if (Array.isArray(value?.data)
            && value?.data.map((item) => (isString(item) ? item.toLowerCase() : item))
              .includes(paramValue.toLowerCase())) {
            rating[placementsType] += 1;
          }
          if (('min' && 'max') in value?.data) {
            const split = paramValue.split(';').map((item) => Number(item));
            // @ts-ignore:next-line
            if (split[0] >= value?.data.min && split[0] <= value?.data.max) {
              rating[placementsType] += 1;
            }
          }
        }
      });
    });
  });
  return rating;
};

export const getPlacementTypeBiggerRating = (rating: {[key: string]: number}): string => {
  return Object.entries(rating).reduce((acc, [key, value]) => {
    if (value > rating[acc]) return key;
    return acc;
  }, Object.keys(rating)[0]);
};
